var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconReactionClap = function SvgIconReactionClap(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D99B57;}\n\t.st1{fill:#FFDD67;}\n\t.st2{fill:#EBA352;}\n\t.st3{fill:#42ADE2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,23.2c0,0-4.8-3.9-7.3-7.8c-1-1.4-4-1.2-5.1,1.5l-16.6,6.4L6.4,17.4c-1.7-1.1-3.9-0.3-4.9,1.7 c-1,1.9-0.4,4.4,1.4,5.4l1.7,1c-1.5-0.2-3.1,0.5-3.8,2c-1,1.9-0.4,4.4,1.4,5.4L6,35.2c-1.7-1.1-3.9-0.3-4.9,1.7 c-1,1.9-0.4,4.4,1.4,5.4c0,0,19.2,11.9,25.8,15.4c5.2,2.9,15.5,4.3,22-3.6C52.5,51.4,46.4,23.2,46.4,23.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.4,23.2c-3.4-2.3-5.7-5.4-7.4-10.1c-0.6-1.6-3-1.9-4.4,0.7c-2,3.8-0.1,6.9,1,8.3l0.5,0.6 c0,0,0.3,1.2,0.9,2.6c-2.9-0.6-6.1,1-8.3,3.9c-2.3,3.1-7.9,8.4-10.2,11.5c-2.9,3.7-2.1,9,1.1,11.4c0,0,16.7,12.2,27.7-2.8 C63.9,37.6,57.8,25.5,54.4,23.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7,27.7c1.7,1.3,2.1,3.7,0.9,5.6c-1.2,1.9-3.6,2.4-5.3,1.2l-26.5-19c-1.7-1.3-2.1-3.7-0.9-5.6 c1.2-1.9,3.6-2.4,5.3-1.2L48.7,27.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35,25.5L18.1,13.3c-1-0.6-1.6-1.7-1.3-3.3c-1.2,2.1-0.4,4.3,1,5.3l16.9,12.2C36.4,28.8,36.7,26.8,35,25.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.1,31.4c1.7,1.3,2.1,3.7,0.9,5.6c-1.2,1.9-3.6,2.4-5.3,1.2L9.2,19c-1.7-1.3-2.1-3.7-0.9-5.6 c1.2-1.9,3.6-2.4,5.3-1.2L40.1,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.9,31.8L9.5,17c-1-0.6-1.6-1.9-1.3-3.3c-1.2,2.1-0.5,4.5,1,5.5l20.5,14.6C31.3,35.1,31.6,33,29.9,31.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.4,39.9c1.7,1.3,2.1,3.7,0.9,5.6c-1.2,1.9-3.6,2.4-5.3,1.2L7.5,27.5c-1.7-1.3-2.1-3.7-0.9-5.6 c1.2-1.9,3.6-2.4,5.3-1.2L38.4,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.9,38.6l-18.1-13c-1-0.6-1.6-2.1-1.2-3.6c-1.4,2-0.9,4.7,0.6,5.7l18.3,12.9C27.3,41.9,27.6,39.9,25.9,38.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.7,49.4c1.7,1.3-10.4,2.6-12.1,1.3L6.9,37.2c-1.7-1.3-2.1-3.7-0.9-5.6c1.2-1.9,3.6-2.4,5.3-1.2L37.7,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.6,38.4c0,0-1.8,9.4-9.2,15c-6.6,5-16.8,0.6-21.7-2.6c-5.1-3.5-7.7-5.2-20-14.6c-2.3-1.8-3-3-2.7-4.9 c-1.8,1.9-0.9,4.9,0.6,6l1.3,0.9c0,0,14.8,10.8,19.8,14.2c4.6,3.2,16.4,8.2,23.8,2.2C59.9,48.2,59.6,38.4,59.6,38.4 M46.9,26.2 c-2.1-2.2-2.2-5.4-2.2-5.4l-0.5-0.6c-0.9-1.1-2.2-3.3-1.7-6c-2,3.7,0,6.7,1,8l0.5,0.6c0,0-0.1,1,0.4,1.7L46.9,26.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "38.7,0 41.2,10.5 46.3,0.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "53.3,4.5 49.4,13.2 58.5,10.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "29.8,1.3 32.2,10.8 24.3,5.7  "
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReactionClap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_reaction_clap.5406dffd.svg";
export { ForwardRef as ReactComponent };